routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsList', {
      url: __env.routes.pqrsList,
      template: `<pqrs-list sh-ctrl="shCtrl"></pqrs-list>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/pqrs/pqrs-list/pqrs-list.config.js
 **/